import React, { useContext } from 'react';
import { AppContext } from "../../context/AppContext";
import {FlagComponent} from "../FlagComponent";

export function InfoBar() {
  const {
    I18N,
    I18NforceUpdate
  } = useContext(AppContext);

  return (
    <dia-info-bar>
      <dia-flex-container>
        <ul>
          <li data-app-version>{ process.env.REACT_APP_VERSION }</li>
        </ul>
        <ul>
          <li>
            <FlagComponent locale={ I18N.getLocale() } text={ I18N.getLocaleDisplayName() }></FlagComponent>
            <dia-tooltip
              data-tooltip-position="bottom"
              data-hover
              data-nested
            >
              <ul>
                { I18N.getLocales().map((locale: string) =>
                  <li key={ locale } data-active={ I18N.getLocale() === locale }>
                    <a href="/" onClick={(event): void => {
                      event.preventDefault();

                      I18N.setLocale(locale, true);
                      I18NforceUpdate();
                    }}>
                      <FlagComponent locale={ locale } text={ I18N.getLocaleDisplayName(locale) }></FlagComponent>
                    </a>
                  </li>
                )}
              </ul>
            </dia-tooltip>
          </li>
        </ul>
      </dia-flex-container>
    </dia-info-bar>
  );
}
